import { Overrides } from '@material-ui/core/styles/overrides';
import { CORPORATE_COLORS } from '@Ui/theme/colors/corporate';

export const formHelperTextOverrides: Overrides = {
  MuiFormHelperText: {
    root: {
      fontSize: '14px',
      lineHeight: '36px'
    }
  }
};
